import React, { useCallback, useContext } from "react"
import { Space, Switch } from "antd"
import { useTranslation } from "react-i18next"
import { ThemeActions, ThemeContext } from "../../../../contexts/ThemeContex"
import FontPicker from "font-picker-react"
import "./Modes.less"

function Modes() {
  const { t } = useTranslation()
  const { themeDispatch, themeState } = useContext(ThemeContext)

  const changeFont = useCallback(
    (e) => {
      themeDispatch({
        type: ThemeActions.ChangeFont,
        payload: {
          currentFont: e,
        },
      })
    },
    [themeDispatch]
  )
  const changeTheme = useCallback(
    (e) => {
      if (e) {
        themeDispatch({
          type: ThemeActions.ChangeTheme,
          payload: {
            currentTheme: "dark",
          },
        })
      } else {
        themeDispatch({
          type: ThemeActions.ChangeTheme,
          payload: {
            currentTheme: "default",
          },
        })
      }
    },
    [themeDispatch]
  )

  return (
    <Space size={10}>
      <Switch
        onChange={(e) => changeTheme(e)}
        checked={themeState.currentTheme === "dark"}
        className="theme-switcher"
        checkedChildren={t("nightTheme")}
        unCheckedChildren={t("dayTheme")}
      />
      <FontPicker
        apiKey="AIzaSyDPtqHOkdnMVZb6wrHcyz1Mwyn0Au-HCbI"
        activeFontFamily={themeState.currentFont}
        onChange={(nextFont) => changeFont(nextFont.family)}
      />
    </Space>
  )
}

export default Modes
